module.exports = __webpack_public_path__ + "static/media/myvnpt-banner.300b1620.png";